;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="16b0dbe6-ace4-4948-8585-9a5237b49dae",e._sentryDebugIdIdentifier="sentry-dbid-16b0dbe6-ace4-4948-8585-9a5237b49dae")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import events from 'events-bus';
import Cookies from '../../node_modules/.pnpm/js-cookie@2.2.1/node_modules/js-cookie/src/js.cookie.js';
import React__default, { useContext } from 'react';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { getLanguageWithFlags, LanguageWithFlag } from './LanguageWithFlag.js';
import styles from './Multilanguage.module.scss.js';

const MULTILANGUAGE_CLASS = 'srh-multilanguage';
const MULTILANGUAGE_CHANGE_EVENT = 'MULTILANGUAGE-CHANGE-v1';
function Multilanguage({ className, }) {
    const { translations, availableLanguages, vendorAssetsURL } = useContext(AppContext);
    const languages = getLanguageWithFlags(availableLanguages, vendorAssetsURL);
    const selectedLanguage = languages.find((language) => language.selected);
    const accessibleText = translations.get('shop.header.multilanguage.accessible.text');
    const onChangeLanguage = (locale) => {
        if (locale === selectedLanguage?.locale)
            return;
        const language = locale.split('-')[0];
        const data = {
            version: 1,
            locale,
        };
        Cookies.set('_zpLanguage', language);
        events.trigger(MULTILANGUAGE_CHANGE_EVENT, data);
    };
    const LANGUAGE_BUTTONS = languages.map((language) => {
        const { locale, selected, label } = language;
        const languageAriaLabel = accessibleText?.replace('${language}', label);
        return (React__default.createElement("button", { "data-zta": `multilanguage-buton-${locale}`, className: classNames(`${MULTILANGUAGE_CLASS}-${locale}`, styles.languageButton, {
                [styles.languageButtonSelected]: selected,
            }), type: "button", key: locale, onClick: () => onChangeLanguage(locale), "aria-label": languageAriaLabel },
            React__default.createElement(LanguageWithFlag, { ...language })));
    });
    return (React__default.createElement("div", { "data-zta": "multi-language", className: className },
        React__default.createElement("div", { "data-zta": "mobile-multilanguage", className: classNames(MULTILANGUAGE_CLASS, styles.mobileMultilanguage) },
            React__default.createElement("div", { className: styles.languageButtons, "data-zta": "language-buttons" },
                React__default.createElement("span", { className: styles.languageButtonLabel, "data-zta": "language-buttons-label" },
                    translations.get('general.language.select'),
                    ":"),
                LANGUAGE_BUTTONS)),
        React__default.createElement("div", { "data-zta": "desktop-multilanguage", className: classNames(MULTILANGUAGE_CLASS, styles.desktopMultilanguage) }, LANGUAGE_BUTTONS)));
}

export { MULTILANGUAGE_CHANGE_EVENT, MULTILANGUAGE_CLASS, Multilanguage as default };
//# sourceMappingURL=Multilanguage.js.map
